import { createFileRoute } from '@tanstack/react-router';
import { LessonsPage } from '@/features/debrief-v2';

export const Route = createFileRoute(
  '/_dashboard/interactions/debrief-v2/$id/lessons'
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  return <LessonsPage sessionId={id} />;
}
